const common = {
  FORM46_ANNUAL_QUOTA_VND: 20000000,
  DATE_FORMAT: 'YYYY-MM-DD',
  DATE_TIME_FORMAT: 'YYYY-MM-DD HH:mm',
  TICKET_STATUS: [
    { value: 'submited', label: 'Submitted' },
    { value: 'approving', label: 'Approving' },
    { value: 'processing', label: 'Processing' },
    { value: 'closed', label: 'Closed' },
  ],
  CONTRACT_FORM_IDS: [3, 5, 8, 22, 28, 34],
  AUTO_CONTRACT_IDS: [30, 31],
  // Ticket detail uses the full page width (data table) with the people panel below.
  WIDE_TICKET_FORM_IDS: [54],
  GAMES: [
    { value: "AOV", label: "AOV" },
    { value: "FF", label: "FF" },
    { value: "FC Online", label: "FC Online" },
    // { value: "BNS", label: "BNS" },
    { value: "3KD", label: "3KD" },
    { value: "DF", label: "DF" },
    { value: "FC", label: "FC" },
    { value: "FCM", label: "FCM" },
    { value: "GnG", label: "GnG" },
    { value: "Reg Craftland", label: "Reg Craftland" },
    { value: "NEW_GAME", label: "New Games" },
    { value: "CODE", label: "CODE" },
    { value: "STUDIO", label: "STUDIO" },
    { value: "FINANCE", label: "FINANCE" },
    { value: "CNB", label: "C&B" },
    { value: "RECRUITMENT_AND_TRAINING", label: "RECRUITMENT AND TRAINING" },
    { value: "ADMIN_GAME", label: "ADMIN GAME" },
    { value: "PURCHASING", label: "PURCHASING" },
    { value: "CS", label: "Customer Services" },
    { value: "IT_HN", label: "IT HN" },
    { value: "IT_HCM", label: "IT HCM" },
    { value: "INFRA", label: "INFRA" },
    { value: "HRBP", label: "HRBP" },
    { value: "PEOPLE", label: "PEOPLE" },
    { value: "ODP", label: "ODP" },
    { value: "PWO", label: "PWO" },
    { value: "TB", label: "TB" },
    { value: "Investment", label: "Investment" },
    { value: "Strategy & Operations", label: "Strategy & Operations" },
    { value: "OTHER", label: "OTHER" },
  ],
  TEAMS_WITH_PM: [],
  COMPANY: [
    { value: "VEE", label: "Công ty Cổ phần Giải trí và Thể thao điện tử Việt Nam" },
    { value: "BMI", label: "Công ty TNHH Dịch vụ phần mềm Bình Minh" },
    { value: "TBI", label: "Công ty TNHH Dịch vụ phần mềm Thiên Bình" },
    { value: "VHT", label: "Công ty TNHH dịch vụ phần mềm Hòa Thái" },
  ],
  GAMES_PM_MAP: {},
  TAP_NGHE: 'Tập nghề',
  CTV_THUONG_XUYEN_THEO_SAN_PHAM: 'CTV thường xuyên (Lương theo sản phẩm)',
  CTV_THUONG_XUYEN_LUONG_CUNG: 'CTV thường xuyên (Lương cứng mỗi tháng)',
  APPROVE_CENTER_USERS: [],
  FORM_19_USERS: [],
  VU_CHI_CONG: '',
  NGUYEN_DAC_BA_NHAT: '',
  NGUYEN_HONG_HANH: '',
  TRAN_TRUNG_KIEN: '',
  NGUYEN_NGOC_TRAM: '',
  VO_TUYEN_CHINH: '',
  NGUYEN_ANH_TUAN: '',
  LUU_DINH_PHUC: '',
  LEGAL_TEAM: [],
  FINANCE_TEAM: [],
  CNB_TEAM: [],
  UQ_TITLE: {
    'Nguyễn Đắc Bá Nhật': 'Giám Đốc Vận Hành Game',
    'Vũ Chí Công': 'Tổng Giám Đốc',
    'An Anh Vũ': 'Trưởng Dự án Blockman Go',
    'Nguyễn Thanh Bình': 'Trưởng dự án Freefire',
    'Nhan Phước Quang': 'Trưởng dự án Fifa Online 4',
  },
  UQ_DATA: [
    {
      "companyCode": "VEE",
      "companyName": "CÔNG TY CỔ PHẦN GIẢI TRÍ VÀ THỂ THAO ĐIỆN TỬ VIỆT NAM",
      "signer": "Nguyễn Đắc Bá Nhật",
      "title": "Giám Đốc Vận Hành Game",
      "uqNumber": "76-2022.VEE_HN/GUQ",
      "date": "21/02/2022"
    },
    {
      "companyCode": "BMI",
      "companyName": "CÔNG TY TNHH DỊCH VỤ PHẦN MỀM BÌNH MINH",
      "signer": "Nguyễn Đắc Bá Nhật",
      "title": "Giám Đốc Vận Hành Game",
      "uqNumber": "78-2022.BM_HN/GUQ",
      "date": "21/02/2022"
    },
    {
      "companyCode": "VHT",
      "companyName": "Công ty TNHH dịch vụ phần mềm Hòa Thái",
      "signer": "Nguyễn Đắc Bá Nhật",
      "title": "Giám Đốc Vận Hành Game",
      "uqNumber": "77-2022.LOL_HN/GUQ",
      "date": "21/02/2022"
    }
  ],
  FEEDBACK_42: [
    {
      id: '1',
      question: 'Logical & Analytical thinking',
      questionDesc: 'Hiểu được logic của sự kiện/mục tiêu của sản phẩm từ đó lên kế hoạch và hoàn thiện sản phẩm bàn giao theo đúng yêu cầu',
      choices: [
        {
          value: '1',
          label: 'Nắm sơ lược yêu cầu của sự kiện, chưa có khả năng tự hình thành logic sự kiện và lên kế hoạch'
        },
        {
          value: '2',
          label: 'Hiểu được logic sự kiện, từ đó hình thành được đầu mục công việc cho bản thân ',
        },
        {
          value: '3',
          label: 'Hiểu được tổng quan cả logic và mục tiêu, thể hiện được ra kết quả sản phẩm (readability, sustainability, testability, applicability, feasibility). Có thể tư vấn điều phối, lên kế hoạch dự án với các bên liên quan để đạt mục tiêu đó',
        },
        {
          value: '4',
          label: 'Hiểu mục tiêu dài hạn của sản phẩm, nhìn nhận được nhiều yếu tố liên quan (các bên liên quan, xu hướng khách hàng, bài học quá khứ), từ đó phân tích đa chiều và lên kế hoạch dự đoán, từ vấn trước các vấn đề có thể xảy ra và phòng ngừa',
        },
      ]
    },
    {
      id: '2',
      question: 'Site quality',
      questionDesc: 'Chất lượng sản phẩm: Chức năng, tốc độ và sự ổn định để đảm bảo trải nghiệm người dùng. Note: Vấn đề lớn là các vấn đề gây ảnh hưởng trực tiếp đến chỉ số của sự kiện và gây ảnh hưởng lớn đến trải nghiệm người dùng',
      choices: [
        {
          value: '1',
          label: 'Có rất nhiều lỗi/vấn đề lớn sau khi launching'
        },
        {
          value: '2',
          label: 'Có một số lỗi/vấn đề lớn sau khi launching',
        },
        {
          value: '3',
          label: 'Có một số lỗi/vấn đề nhỏ và không có vấn đề lớn sau khi launching',
        },
        {
          value: '4',
          label: 'Không có lỗi/vấn đề nào sau khi launching',
        },
      ]
    },
    {
      id: '3',
      question: 'Communication & Collaboration',
      questionDesc: 'Team dev chủ động giao tiếp, hỗ trợ và đóng góp',
      choices: [
        {
          value: '1',
          label: 'Nhận thông tin một chiều từ khách hàng'
        },
        {
          value: '2',
          label: 'Nghe, hiểu yêu cầu và trả lời thông tin theo yêu cầu của khách hàng',
        },
        {
          value: '3',
          label: 'Chủ động trao đổi hai chiều, tham gia thảo luận để làm rõ yêu cầu của khách hàng, đưa ra nhận định của bản thân mang tính xây dựng và có thể thống nhất được ý kiến chung. Có khả năng quản lý và điều phối dự án nhỏ, team nhỏ',
        },
        {
          value: '4',
          label: 'Chủ động nghiên cứu, tổng hợp dữ liệu để tư vấn lựa chọn hiệu quả nhất cho khách hàng. Chủ động chia sẻ kiến thức để xây dựng năng lực cho khách hàng và thúc đẩy phối hợp làm việc hiệu quả. Có khả năng quản lý điều phối dự án lớn, team gồm nhiều bộ phận cùng tham gia',
        },
      ]
    },
    {
      id: '4',
      question: 'Timeliness',
      questionDesc: 'Tiến độ của dự án',
      choices: [
        {
          value: '1',
          label: 'Thường xuyên trễ tasks và/hoặc không đảm bảo được thời gian testing cho một số dự án/ nhiệm vụ'
        },
        {
          value: '2',
          label: 'Đôi khi trễ tasks và/hoặc không đảm bảo được thời gian testing cho một số dự án/ nhiệm vụ',
        },
        {
          value: '3',
          label: 'Thường xuyên hoàn thành các tasks đúng hạn, đảm bảo sản phẩm cuối cùng ra theo đúng tiến độ dự kiến ',
        },
        {
          value: '4',
          label: 'Luôn luôn hoàn thành tasks đúng và trước thời hạn, chủ động đảm bảo thời gian cho testing của dự án',
        },
      ]
    },
    {
      id: '5',
      question: 'Overall',
      questionDesc: 'Nhìn chung, tôi thấy hài lòng với dự án đã hoàn thành',
      choices: [
        {
          value: '1',
          label: 'Rất không đồng ý'
        },
        {
          value: '2',
          label: 'Không đồng ý',
        },
        {
          value: '3',
          label: 'Đồng ý',
        },
        {
          value: '4',
          label: 'Rất đồng ý',
        },
      ]
    },
  ],
  INITIAL_TASKS: {
    READY_FOR_CKS: 'Hợp đồng đã được kiểm tra, có thể tiến hành ký Chữ ký số'
  },
  DEFAULT_FORM_NODES: [{ "form_name": "vat", "nodes": [{ "is_leaf": false, "leaf_html": "", "parent": null, "question": "Tra cứu mã số thuế", "is_root": true, "depth": 0, "node_id": 1, "answer": "", "path": [1], "children": [2, 3, 4, 5] }, { "is_leaf": true, "leaf_html": "<p>\nCÔNG TY CỔ PHẦN GIẢI TRÍ VÀ THỂ THAO ĐIỆN TỬ VIỆT NAM<br/>\n\nMã số thuế: 0105301438<br/>\n\nĐịa chỉ: Tầng 6, Tòa nhà Capital Place, 29 Liễu Giai, Phường Ngọc Hà, Thành phố Hà Nội, Việt Nam\n</p>", "parent": 1, "question": "", "is_root": false, "depth": 1, "node_id": 2, "answer": "CÔNG TY CỔ PHẦN GIẢI TRÍ VÀ THỂ THAO ĐIỆN TỬ VIỆT NAM", "path": [1, 2], "children": [] }, { "is_leaf": true, "leaf_html": "\n<p>\nCÔNG TY TNHH DỊCH VỤ PHẦN MỀM BÌNH MINH<br/>\n\nMã số thuế: 0106803303\n<br/>\n\nĐịa chỉ: Tầng 6, Tòa nhà Capital Place, 29 Liễu Giai, Phường Ngọc Hà, Thành phố Hà Nội, Việt Nam\n</p>", "parent": 1, "question": "", "is_root": false, "depth": 1, "node_id": 3, "answer": "CÔNG TY TNHH DỊCH VỤ PHẦN MỀM BÌNH MINH", "path": [1, 3], "children": [] }, { "is_leaf": true, "leaf_html": "<p>\nCÔNG TY TNHH DỊCH VỤ PHẦN MỀM THIÊN BÌNH<br/>\n\nMã số thuế: 0106803215\n<br/>\n\nĐịa chỉ: Tầng 6, Tòa nhà Capital Place, 29 Liễu Giai, Phường Ngọc Hà, Thành phố Hà Nội, Việt Nam\n</p>", "parent": 1, "question": "", "is_root": false, "depth": 1, "node_id": 4, "answer": "CÔNG TY TNHH DỊCH VỤ PHẦN MỀM THIÊN BÌNH", "path": [1, 4], "children": [] }, { "is_leaf": true, "leaf_html": "<p>\nCông ty TNHH dịch vụ phần mềm Hòa Thái<br/>\n\nMã số thuế: 2801724858\n<br/>\n\nĐịa chỉ: Tầng 6, Tòa nhà Capital Place, 29 Liễu Giai, Phường Ngọc Hà, Thành phố Hà Nội, Việt Nam\n</p>", "parent": 1, "question": "", "is_root": false, "depth": 1, "node_id": 5, "answer": "Công ty TNHH dịch vụ phần mềm Hòa Thái", "path": [1, 5], "children": [] }], "form_id": 6 }],
  DEFAULT_NODES:
    [
      { "is_leaf": false, "is_root": true, "parent": null, "node_name": "Trang chu", "priority": null, "visible": true, "depth": 0, "node_id": 1, "link": null, "node_description": "", "path": [1], "content": null, "children": [6, 7] },
      {
        "children": [], "content": null, "depth": 1, "is_leaf": true, "is_root": false, "link": "/form/6",
        "node_description": "Thông tin viết hoá đơn công ty", "node_id": 6, "node_name": "Mã số thuế công ty", "parent": 1, "path": [1, 6], "priority": 1, "visible": true,
      },
      {
        "children": [], "content": null, "depth": 1, "is_leaf": true, "is_root": false, "link": "/we_listen",
        "node_description": "Gửi ý kiến của bạn tới các quản lý", "node_id": 7, "node_name": "We Listen", "parent": 1, "path": [1, 7], "priority": 2, "visible": true,
      }
    ],

  CONTRACT_US_INFO: [],
  CONTRACT_US_NODES: [
    {
      "node_id": 1,
      "is_root": true,
      "is_leaf": false,
      "question": "Bạn muốn tìm liên hệ cho loại công việc nào",
      "answer": "",
      "link": "",
      "fallback": "",
      "parent": null,
      "path": [1],
      "children": [2, 3, 4, 5, 6, 27, 48, 7, 8, 9, 10, 11, 28, 26],
      "inline_tooltip": ""
    },
    {
      "node_id": 2,
      "is_root": false,
      "is_leaf": false,
      "question": "Chọn khu vực",
      "answer": "Thanh toán",
      "link": "",
      "fallback": "",
      "parent": 1,
      "path": [1, 2],
      "children": [12, 13],
      "inline_tooltip": ""
    },
    {
      "node_id": 3,
      "is_root": false,
      "is_leaf": false,
      "question": "Chọn khu vực",
      "answer": "Vé máy bay",
      "link": "",
      "fallback": "",
      "parent": 1,
      "path": [1, 3],
      "children": [14, 15],
      "inline_tooltip": ""
    },
    {
      "node_id": 4,
      "is_root": false,
      "is_leaf": false,
      "question": "Chọn khu vực",
      "answer": "Khách sạn",
      "link": "",
      "fallback": "",
      "parent": 1,
      "path": [1, 4],
      "children": [16, 17],
      "inline_tooltip": ""
    },
    {
      "node_id": 5,
      "is_root": false,
      "is_leaf": false,
      "question": "Chọn khu vực",
      "answer": "Studio ( Phòng thu)",
      "link": "",
      "fallback": "",
      "parent": 1,
      "path": [1, 5],
      "children": [18, 19],
      "inline_tooltip": ""
    },
    {
      "node_id": 6,
      "is_root": false,
      "is_leaf": true,
      "question": "Chọn khu vực",
      "answer": "Đào tạo/ Tuyển dụng",
      "link": ["TRAN_HOAI_THUONG"],
      "fallback": "",
      "parent": 1,
      "path": [1, 6],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 7,
      "is_root": false,
      "is_leaf": true,
      "question": "Chọn khu vực",
      "answer": "Công văn/ Hồ sơ Giải đấu",
      "link": ["NGUYEN_BUI_ANH_TUAN"],
      "fallback": "",
      "parent": 1,
      "path": [1, 7],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 8,
      "is_root": false,
      "is_leaf": true,
      "question": "Chọn khu vực",
      "answer": "Purchase/ Mua hàng/ Mua Online các phần mềm bản quyền, âm nhạc, hình ảnh",
      "link": ["VO_TUYEN_CHINH"],
      "fallback": "",
      "parent": 1,
      "path": [1, 8],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 9,
      "is_root": false,
      "is_leaf": false,
      "question": "Chọn khu vực",
      "answer": "IT/ Cấp phát máy bàn/ Cấp phát laptop/ Cấp phát máy vi tính để bàn/ Cấp phát màn hình",
      "link": "",
      "fallback": "",
      "parent": 1,
      "path": [1, 9],
      "children": [20, 21],
      "inline_tooltip": ""
    },
    {
      "node_id": 10,
      "is_root": false,
      "is_leaf": false,
      "question": "Chọn khu vực",
      "answer": "Nhân sự/ Bảo hiểm y tế/ Bảo hiểm xã hội/ Mã số thuế cá nhân/",
      "link": "",
      "fallback": "",
      "parent": 1,
      "path": [1, 10],
      "children": [22, 23],
      "inline_tooltip": ""
    },
    {
      "node_id": 11,
      "is_root": false,
      "is_leaf": false,
      "question": "Chọn loại nhân viên ",
      "answer": "Xin quyền access hệ thống GIGI",
      "link": "",
      "fallback": "",
      "parent": 1,
      "path": [1, 11],
      "children": [24, 25],
      "inline_tooltip": ""
    },
    {
      "node_id": 12,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HN",
      "link": ["LE_THI_THANH"],
      "fallback": "",
      "parent": 2,
      "path": [1, 2, 12],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 13,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HCM",
      "link": ["NGUYEN_THI_THUY_AN"],
      "fallback": "",
      "parent": 2,
      "path": [1, 2, 13],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 14,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HN",
      "link": ["PHAM_THI_THU_TRANG"],
      "fallback": "NGUYEN_MANH_LINH",
      "parent": 3,
      "path": [1, 3, 14],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 15,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HCM",
      "link": ["TRINH_THI_BINH"],
      "fallback": "NGUYEN_MANH_LINH",
      "parent": 3,
      "path": [1, 3, 15],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 16,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HN",
      "link": ["PHAM_THI_THU_TRANG"],
      "fallback": "NGUYEN_MANH_LINH",
      "parent": 4,
      "path": [1, 4, 16],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 17,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HCM",
      "link": ["PHAM_THI_THU_TRANG"],
      "fallback": "NGUYEN_MANH_LINH",
      "parent": 4,
      "path": [1, 4, 17],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 18,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HN",
      "link": ["VO_THANH_SON"],
      "fallback": "",
      "parent": 5,
      "path": [1, 5, 18],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 19,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HCM",
      "link": ["HUYNH_HO_DONG"],
      "fallback": "",
      "parent": 5,
      "path": [1, 5, 19],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 20,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HN",
      "link": ["TRAN_QUANG_TUNG"],
      "fallback": "TRAN_DINH_HOANG_NAM",
      "parent": 9,
      "path": [1, 9, 20],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 21,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HCM",
      "link": ["VU_QUANG_TUAN"],
      "fallback": "TRAN_DINH_HOANG_NAM",
      "parent": 9,
      "path": [1, 9, 21],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 22,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HN",
      "link": ["NGUYEN_NGOC_TRAM"],
      "fallback": "LUU_LE_THU_TRANG",
      "parent": 10,
      "path": [1, 10, 22],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 23,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "HCM",
      "link": ["LUU_THI_MY_HANH"],
      "fallback": "LUU_LE_THU_TRANG",
      "parent": 10,
      "path": [1, 10, 23],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 24,
      "is_root": false,
      "is_leaf": true,
      "question": "Chọn loại nhân viên ",
      "answer": "Nhân viên chính thức",
      "link": ["PHAM_NGUYEN_MINH_NGOC"],
      "fallback": "",
      "parent": 11,
      "path": [1, 11, 24],
      "children": "",
      "inline_tooltip": "Bạn vui lòng điền Form <a href=\"https://docs.google.com/forms/u/1/d/e/1FAIpQLSfi3ua3I3ylAUDcf30-MkBto-fHkIBFNtBPILMXXdWdMx0djA/viewform\" target=\"_blank\">NÀY</a> trước khi liên hệ với nhân sự phụ trách nhé."
    },
    {
      "node_id": 25,
      "is_root": false,
      "is_leaf": true,
      "question": "Chọn loại nhân viên ",
      "answer": "Cộng tác viên",
      "link": ["LUU_THI_MY_HANH"],
      "fallback": "",
      "parent": 11,
      "path": [1, 11, 25],
      "children": "",
      "inline_tooltip": "Bạn vui lòng điền Form <a href=\"https://docs.google.com/forms/d/e/1FAIpQLSdeTCsTG1wVb2GjNUJ2mjEInudigkr4fsXhumCttoeKBwxIqQ/viewform\" target=\"_blank\">NÀY</a> trước khi liên hệ với nhân sự phụ trách nhé."
    },
    {
      "node_id": 26,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "Các tính năng trên GIGI/ Góp ý về các tính năng/Hệ thống bị lỗi",
      "link": ["NGUYEN_THI_HONG_HANH"],
      "fallback": "",
      "parent": 1,
      "path": [1, 26],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 27,
      "is_root": false,
      "is_leaf": true,
      "question": "Chọn khu vực",
      "answer": "Hợp đồng",
      "link": ["CAO_HOANG_BAO"],
      "fallback": "",
      "parent": 1,
      "path": [1, 27],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 28,
      "is_root": false,
      "is_leaf": false,
      "question": "Chọn bộ phận",
      "answer": "Thông tin liên hệ quản lý các Bộ phận",
      "link": "",
      "fallback": "",
      "parent": 1,
      "path": [1],
      "children": [29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47],
      "inline_tooltip": ""
    },
    {
      "node_id": 29,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "AOV",
      "link": ["LE_DUC_ANH"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 29],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 30,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "FF",
      "link": ["HOANG_MINH_TRI"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 30],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 31,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "FO4",
      "link": ["NHAN_PHUOC_QUANG"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 31],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 32,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "BNS",
      "link": ["NGUYEN_HUU_THINH"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 32],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 33,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "LOL",
      "link": ["NHAN_PHUOC_QUANG"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 33],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 34,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "BOO",
      "link": ["AN_PHUONG_LINH"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 34],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 35,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "BMG",
      "link": ["TRUONG_THANH_PHUONG_DUNG"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 35],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 36,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "PNC",
      "link": ["NGUYEN_NHU_HUY"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 36],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 37,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "PEOPLE",
      "link": ["NGUYEN_MANH_LINH"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 37],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 38,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "STUDIO",
      "link": ["HUYNH_HO_DONG"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 38],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 39,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "FINANCE",
      "link": ["NGUYEN_THI_VAN_ANH"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 39],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 40,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "C&B",
      "link": ["LUU_LE_THU_TRANG"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 40],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 41,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "RECRUITMENT",
      "link": ["TRAN_HOAI_THUONG"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 41],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 42,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "PURCHASING",
      "link": ["VO_TUYEN_TRINH"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 42],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 43,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "ADMIN_GAME",
      "link": ["NGUYEN_THI_HONG_HANH"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 43],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 44,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "SOURCING_GAMES",
      "link": ["NGUYEN_DAC_BA_NHAT"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 44],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 45,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "IT_HN",
      "link": ["NGUYEN_THANH_HAI"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 45],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 46,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "IT_HCM",
      "link": ["HO_VINH_NGHI"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 46],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 47,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "INFRA",
      "link": ["PHAM_VINH_THANH"],
      "fallback": "",
      "parent": 28,
      "path": [1, 28, 47],
      "children": "",
      "inline_tooltip": ""
    },
    {
      "node_id": 48,
      "is_root": false,
      "is_leaf": true,
      "question": "",
      "answer": "Admin Game (Phụ trách các hợp đồng, thanh toán)",
      "link": ["NGUYEN_THI_NGOC_ANH", "NGUYEN_THI_THU_HUONG"],
      "fallback": "",
      "parent": 1,
      "path": [1, 48],
      "children": "",
      "inline_tooltip": ""
    }
  ]
};

let commonSensitiveLoaded = false;

export const loadCommonSensitiveData = async () => {
  if (commonSensitiveLoaded) {
    return;
  }

  const { applyCommonSensitiveData } = await import('./sensitiveData');
  applyCommonSensitiveData(common);
  commonSensitiveLoaded = true;
};

export default common;
